import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import { reportApi } from '@/shared/api'
import { showErrorMessage } from '@/shared/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  imageId: Number,
},
  emits: ['rotated'],
  setup(__props, { emit }) {

const props = __props





const handleRotateImage = async (): Promise<void> => {
  const [error] = await reportApi.rotateImage(props.imageId)

  if (error) {
    showErrorMessage(error)
  } else {
    emit('rotated')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_icon_template = _resolveComponent("icon-template")!

  return (_openBlock(), _createElementBlock("div", {
    class: "rotate-image",
    onClick: handleRotateImage
  }, [
    _createVNode(_component_icon_template, {
      class: "rotate-image__icon",
      name: "rotate",
      width: "20",
      height: "20"
    })
  ]))
}
}

})